import React, { useState, useRef } from "react"
import { Col, Row, Card, CardBody, Spinner, Button } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { useStore1Dispatch, useStore1Selector } from "index";
import { Login, loginUser } from "../../Redux/Slices/userSlice";
import usePost from "../../hooks/usePost";
import { useHistory } from "react-router-dom";
import { UpdatePasswordMsg, updateProfileMsg } from "../../constant/NotifyMessage";
import { LoginRoute } from "../../constant/RouteName";
import { FcAddImage } from "react-icons/fc";


function CustomerProfile() {

    const history = useHistory()
    const dispatch = useStore1Dispatch();
    const userDet = useStore1Selector(loginUser)
    const [profile, setProfile] = useState();
    const [loadBtn, setBtnLoad] = useState(false);
    const [loadBtn2, setBtnLoad2] = useState(false);
    const [profileServer, setProfileServer] = useState();
    const [photoPassport, setPhotoPassport] = useState();
    const [passportPhotoPreview, setPassportPhotoPreview] = useState(null);
    const { execute, data } = usePost()
    const token = userDet?.token;

    const handlePhotoPassport = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhotoPassport(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPassportPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            // Reset the preview if no file is selected
            setPassportPhotoPreview(null);
        }
    }

    const handleValidSubmit = (e, values) => {
        e.preventDefault();
        setBtnLoad2(true)
        const Method = 'PATCH', endPoint = 'users/updateMe', isJSON = true;

        const formdata = new FormData();
        formdata.append("firstName", values.firstName);
        formdata.append("lastName", values.lastName);
        formdata.append("phoneNumber", values.phoneNumber);
        formdata.append("email", values.email);
        formdata.append("address", values.address);
        formdata.append("companyName", values.companyName);
        formdata.append("jobTitle", values.jobTitle);
        formdata.append("province", values.province);
        formdata.append("city", values.city);
        formdata.append("postalCode", values.postalCode);
        formdata.append("referralCode", values.referralCode);
        formdata.append("accountNumber", values.accountNumber);
        formdata.append("bankName", values.bankName);
        formdata.append("accountType", values.accountType);

        // Append passport photo only if it's provided
        if (photoPassport) {
            formdata.append("passportPhoto", photoPassport);
        }

        // Append profile photo only if it's provided
        if (profileServer) {
            formdata.append("photoProfile", profileServer);
        }

        formdata.append("idNumber", values.idNumber);
        execute(endPoint, formdata, Method, updateProfileMsg, token, isJSON)
    }

    const refFileUpload = useRef(null);
    const onThumbChangeClick = () => {
        if (refFileUpload) {
            refFileUpload.current.dispatchEvent(new MouseEvent('click'));
        }
    };

    const changeThumb = (event) => {
        if (event.target.files && event.target.files[0]) {
            setProfileServer(event.target.files[0]);

            const reader = new FileReader();
            reader.onload = (loadEvent) => {
                setProfile(loadEvent.target.result);
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };

    const updatePassword = (e, values) => {
        e.preventDefault();
        setBtnLoad(true)

        const Method = 'PATCH', endPoint = 'users/updateMyPassword';
        const raw = JSON.stringify({
            "passwordCurrent": values.currentPassword,
            "password": values.newPassword,
            "passwordConfirm": values.confirmPassword
        });
        execute(endPoint, raw, Method, UpdatePasswordMsg, token)
    }

    if (data?.status === "success") {
        dispatch(Login(""));
        history.push(LoginRoute)
    }

    return (
        <>
            <AvForm className="form-horizontal mt-4" onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>
                <div className="d-flex justify-content-center align-items-center mb-3">
                    <img src={profile ? profile : userDet?.data?.data?.photoProfile} alt="Upload image" className="rounded-circle" width={100} height={100} />
                    <Button size="sm" variant="separator-light" className="btn-icon btn-icon-only position-absolute rounded s-0 b-0 mt-5"
                        onClick={onThumbChangeClick}
                    >
                        <FcAddImage size={40} />
                    </Button>
                    <input type="file" ref={refFileUpload} className="file-upload d-none" accept="image/*" onChange={changeThumb} />
                </div>

                <Row className="d-flex flex-row desktop__only">
                    {/* Personal Information Card */}
                    <Col md={7} lg={7} xs={12} sm={12}>
                        <Card className="h-100-mobile">
                            <CardBody>
                                <h5 className="card-title section__header">Personal details</h5>
                                <Row>
                                    <Col md={6}>
                                        <AvField value={userDet?.data?.data?.firstName} name="firstName" label="First Name" type="text" required />
                                    </Col>
                                    <Col md={6}>
                                        <AvField value={userDet?.data?.data?.lastName} name="lastName" label="Last Name" type="text" required />
                                    </Col>
                                </Row>
                                <AvField value={userDet?.data?.data?.email} name="email" label="Email" className="form-control" type="email" required />
                                <AvField value={userDet?.data?.data?.phoneNumber} name="phoneNumber" label="Phone Number" type="number" required />
                            </CardBody>
                        </Card>
                    </Col>
                    {/* Employment Information Card */}
                    <Col md={5} lg={5} xs={12} sm={12} >
                        <Card className="h-100-mobile">
                            <CardBody>
                                <h5 className="card-title section__header">Employment details</h5>
                                <AvField value={userDet?.data?.data?.companyName} name="companyName" label="Company Name" type="text" required />
                                <AvField value={userDet?.data?.data?.jobTitle} name="jobTitle" label="Job Title" className="form-control" type="text" required />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row className="d-flex flex-row desktop__only">
                    {/* Address Card */}
                    <Col md={6} lg={6} xs={12} sm={12}>
                        <Card className="h-100-mobile">
                            <CardBody>
                                <h5 className="card-title section__header">Address</h5>
                                <AvField value={userDet?.data?.data?.streetAddress} name="address" label="Address" type="text" required />
                                <Row>
                                    <Col md={6}>
                                        <AvField value={userDet?.data?.data?.city} name="city" label="City" type="text" required />
                                    </Col>
                                    <Col md={6}>
                                        <AvField value={userDet?.data?.data?.province} name="province" label="Province" type="text" required />
                                    </Col>
                                </Row>
                                <AvField value={userDet?.data?.data?.postalCode} name="postalCode" label="Postal Code" type="text" required />
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Banking Information Card */}
                    <Col md={6} lg={6} xs={12} sm={12}>
                        <Card className="h-100-mobile">
                            <CardBody>
                                <h5 className="card-title section__header">Banking Information</h5>
                                <AvField value={userDet?.data?.data?.accountNumber} name="accountNumber" label="Account Number" type="number" required />
                                <AvField name="accountType" value={userDet?.data?.data?.accountType} label="Account Type" type="select" required>
                                    <option> {userDet?.data?.data?.accountType} </option>
                                    <option> Savings </option>
                                    <option> Current/Cheque </option>
                                </AvField>
                                <AvField value={userDet?.data?.data?.bankName} name="bankName" label="Bank Name" type="text" required />
                            </CardBody>
                        </Card>

                    </Col>
                </Row>

                <Row className="desktop__only">
                    <Col md={7} lg={7} xs={12} sm={12}>
                        <Card className="h-100-mobile">
                            <CardBody>
                                <>
                                    <h5 className="card-title section__header">Additional details</h5>
                                    <AvField value={userDet?.data?.data?.referralCode} name="referralCode" label="Referral Code" type="text" required />
                                    <AvField value={userDet?.data?.data?.idNumber} name="idNumber" label="ID Number" className="form-control" type="text" required />
                                    <AvField
                                        name="passportPhoto"
                                        label="Upload Your Passport Photo"
                                        className="form-control"
                                        type="file"
                                        onChange={handlePhotoPassport}
                                    />
                                </>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={5} lg={5} xs={12} sm={12} className="d-flex justify-content-end">
                        <Card className="w-100 h-100-mobile">
                            <CardBody>
                                {/* Display the image from the server */}
                                {userDet?.data?.data?.passportPhoto && !passportPhotoPreview && (
                                    <img
                                        src={userDet.data.data.passportPhoto}
                                        alt="Passport from Server"
                                        className="img-fluid"
                                        style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '5px', }}
                                    />
                                )}

                                {/* Display the uploaded image preview */}
                                {passportPhotoPreview && (
                                    <img
                                        src={passportPhotoPreview}
                                        alt="Uploaded Passport"
                                        className="img-fluid"
                                        style={{ width: '100%', height: '350px', objectFit: 'cover', borderRadius: '5px' }}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Submit Button */}
                <div className="text-center">
                    <button className="btn custom-btn  text-white " type="submit">
                        {!loadBtn2 ? <span className="me-2">Update details</span> : <span> <Spinner as="span" animation="border" size="sm" /> Loading...</span>}
                    </button>
                </div>
            </AvForm >

            <AvForm
                className="form-horizontal mt-4 " onValidSubmit={(e, v) => { updatePassword(e, v) }} >
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <div className="mb-3">
                                    <AvField
                                        name="currentPassword"
                                        label="Current Password"
                                        className="form-control"
                                        placeholder="Enter your password"
                                        type="password"
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <AvField
                                        name="newPassword"
                                        label="New Password"
                                        className="form-control"
                                        placeholder="Enter your password"
                                        type="password"
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <AvField
                                        name="confirmPassword"
                                        label="Confirm Password"
                                        className="form-control"
                                        placeholder="Re enter your password"
                                        type="password"
                                        required
                                    />
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
                <div className="mb-3  text-center">
                    <button className="btn custom-btn  text-white " type="submit">
                        {
                            !loadBtn ? <span className="me-2">Update password</span> : null
                        }
                        {
                            !loadBtn ? null : <span>  <Spinner as="span" animation="border" size="sm" /> Loading...</span>
                        }
                    </button>
                </div>
            </AvForm>

        </>
    )
}

export default CustomerProfile